var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,21.93c2.89-4.31,2.91-6.19,5.01-9.76,.26-.5,.78-.82,1.35-.82h8.19c.41,.01,.8,.17,1.08,.47l11.19,11.52c.56,.58,.57,1.5,.02,2.09l-6.08,6.5c-.6,.64-1.62,.64-2.22-.01l-2.49-2.7v23.17c0,.84-.68,1.51-1.51,1.51H17.46c-.84,0-1.51-.68-1.51-1.51V29.23l-2.49,2.7c-.6,.64-1.62,.65-2.22,.01l-6.08-6.5c-.55-.59-.55-1.51,.02-2.09l11.2-11.55c.29-.29,.68-.46,1.08-.46h8.19c.57,0,1.08,.31,1.34,.82,2.12,3.72,2.76,6.63,5.01,9.78h0Zm-7.21-7.55h-6.7l-9.75,10.05,3.98,4.26,4.01-4.36c.93-1.02,2.63-.35,2.63,1.03v25.54h26.05V25.37c0-1.38,1.7-2.04,2.63-1.03l4.01,4.36,3.98-4.26-9.75-10.04h-6.7c-2.1,4.26-2.84,7.43-6.13,10.93-.59,.6-1.57,.6-2.16,0-2.32-2.16-4.1-6.5-6.12-10.94h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTop);
export default __webpack_public_path__ + "static/media/icon_top.79a2e48d.svg";
export { ForwardRef as ReactComponent };